import { render, staticRenderFns } from "./CheckWrap.vue?vue&type=template&id=1e6a6132&"
import script from "./CheckWrap.vue?vue&type=script&lang=js&"
export * from "./CheckWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports